import 'bootstrap/dist/css/bootstrap.css';

import * as React from 'react';
import { createBrowserHistory } from 'history';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';

import { HelmetProvider } from 'react-helmet-async';

// Create browser history to use in the Redux store
const baseElement = document.getElementsByTagName('base')[0];
const baseUrl = baseElement ? baseElement.getAttribute('href') || undefined : undefined;
createBrowserHistory({ basename: baseUrl });

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(
  <HelmetProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </HelmetProvider>,
);

registerServiceWorker();
